module.exports = __webpack_public_path__ + "img/alarm-clock-1.ca1109cb.png";